import { useEffect, useState } from "react"
import { createContainer } from "unstated-next"
import moment from 'moment';
import 'moment/locale/fr';
import useUser from "../Shared/UserProvider/useUser";

const OrderStore = () => {
  const {user} = useUser()
  const [orders, setOrders] = useState([])
  const [opened, setOpened] = useState(true);
  const [pausedAt, setPausedAt] = useState(null);
  const [sync, setSync] = useState(false);
  const [posBrandPlatformsInError, setPosBrandPlatformsInError] = useState([])
  const [toasts, setToasts] = useState([]);

  const [dateRange, setDateRange] = useState({
    sd: moment().utc().add(-1, 'day').startOf('day'),
    ed: moment().utc().endOf('day')
  });
  const [selectedPlatform, setSelectedPlatform] = useState([]);


  useEffect(() => {
    setPosBrandPlatformsInError([]);
    setOrders([]);
    setToasts([]);
    setSync(false);
    setPausedAt(null);
    setOpened(true);
  },[user])

  const addToast = (orderInfo) => {
    setToasts(prev => {
      const existingToast = prev.find(o => o.order.id === orderInfo.order.id && o.type === orderInfo.type);
      if(existingToast){
        const notify = (orderInfo.type ==='NEW' && orderInfo.order.status === 'RECEIVED' ) || orderInfo.order.status !== existingToast.order.status || orderInfo.type !== existingToast.type;
        if (notify) {
          return prev.map(o => o.order.id === orderInfo.order.id && o.type === orderInfo.type ? orderInfo : o);
        }
        else {
          return prev
        }
      }
      return [...prev, orderInfo];
    });
  };

  const clearMissingToasts = (orders) => {
    setToasts(prev => {
      const currentIds = new Set(prev.map(o => o.order.id));
      const newIds = new Set(orders.map(o => o.id));
      const toRemove = [...currentIds].filter(id => !newIds.has(id));
      if(toRemove.length > 0) {
        return prev.filter(o => !toRemove.includes(o.order.id));
      }
      return prev;
    });
  }


  const getToast = (id) => {
    return toasts.filter(o => o.order.id === id);
  }

  return {
    orders, setOrders,
    opened, setOpened,
    pausedAt, setPausedAt,
    sync, setSync,
    posBrandPlatformsInError, setPosBrandPlatformsInError,
    dateRange, setDateRange,
    selectedPlatform, setSelectedPlatform,
    toasts, addToast, setToasts, getToast,clearMissingToasts
  }
}

export default createContainer(OrderStore)
